module.exports = __webpack_public_path__ + "logo_genom23.png?346dcdda07657f480512605f4ee739c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_genom23.png
// module id = 110
// module chunks = 0